import { render, staticRenderFns } from "./indexInformation.vue?vue&type=template&id=054019f7"
import script from "./indexInformation.vue?vue&type=script&lang=ts"
export * from "./indexInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HtmlBrandButton: require('/codebuild/output/src1993466134/src/acredo-website/components/html/htmlBrandButton.vue').default})
